var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPinOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.35 1.15a.5.5 0 01.71 0l4.79 4.79a.5.5 0 01-.35.85h-1.29l-2.5 2.5.25 2.25a.5.5 0 01-.85.4L7.6 9.44l-4.24 4.24a.75.75 0 01-1.06-1.06L6.54 8.4 4.04 5.9a.5.5 0 01.4-.85l2.25.25 2.5-2.5V1.5a.5.5 0 01.16-.35z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.2 2.2l11.6 11.6",
    stroke: "white",
    strokeWidth: 2.6,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.2 2.2l11.6 11.6",
    stroke: "black",
    strokeWidth: 1.3,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinOff);
export default __webpack_public_path__ + "static/media/pin-off.0f8204b8b86dd229f82802c22c8537c2.svg";
export { ForwardRef as ReactComponent };